import React, { Component } from 'react';
import { connect } from 'react-redux';
import { uniq } from 'lodash';
import Toolbar from 'base/components/common/Toolbar';
import Modal from 'base/components/Modal';

import StudentsTable from '../components/StudentsTable';
import EditStudentForm from '../components/EditStudentForm';
import EditGroup from '../components/EditGroup';
import MakeMail from '../components/MakeMail';
import Filter from '../components/Filter';
import { fetchAllStudents } from 'modules/Admin/redux/actions/getStudentsAction';
import { deleteStudent } from 'modules/Admin/redux/actions/deleteStudent';
import { updateStudent } from 'modules/Admin/redux/actions/updateStudent';
import API, { AUTH_HEADER } from 'base/api';
import { addFilterStudents, removeFilterStudents } from 'modules/Admin/redux/actions/filterStudents';

const AdvanceSearch = (props) => {
  const { onChange } = props;
  return(
    <div className="advance-search">
      <input type="search" className="cc-search-input" placeholder="Po nazwisku"
        data-search="surname"
        onChange={(e) => onChange("surname", e.target.value)}
      />
      <input type="search" className="cc-search-input" placeholder="Po indeksie"
        data-search="index"
        onChange={(e) => onChange("index", e.target.value)}
      />
      <input type="search" className="cc-search-input" placeholder="Po mailu"
        data-search="mail"
        onChange={(e) => onChange("mail", e.target.value)}
      />
    </div>
  )
}

const Stats = (props) => {
  const { data } = props;
  const numberOfAll = data.length;
  const depArr = data.map( item => item.department);
  const info = depArr.reduce((b,c)=>((b[b.findIndex(d=>d.el===c)]||b[b.push({el:c,count:0})-1]).count++,b),[]);

  return(
    <div className="stats-wrapper">
      <p>Wyświetleni: <strong>{numberOfAll}</strong></p>
      {info.map( (item,i) =>
        <p key={i}>{item.el} : <strong>{item.count}</strong></p>
      )}
    </div>
  )
}

class ManageStudentsView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      editStudent: false,
      editMail: false,
      editGroup: false,
      mailRecipients: [],
      isSending: false,
      filter: {
        searchType: null,
        text: '',
        isExact: false
      }
    }
  }

  deleteStudent = (id) => {
    const { dispatch } = this.props;
    if(window.confirm("AR JU SZUR? Chesz usunąć tego studenciaka ?? ")) {
      dispatch(deleteStudent(id))
    }
  }

  deleteGroupStudent = (ids) => {
    const { dispatch } = this.props;
    if ( window.confirm("AR JU SZUR? Wypieprzysz " + ids.length + " studenciaków :O")) {
      ids.forEach(id => {
        console.log("Deleted", id);
        dispatch(deleteStudent(id));
      })
    }
  }

  handleEdit = (id) => {
    const { data } = this.props;
    const student = data.find( e => e._id === id);
    this.setState({editStudent: student});
  }

  editGroup = (ids) => {
    // console.log(ids)
    const firstStudent = this.props.data.find( e => e._id === ids[0]);
    this.setState({
      editGroup: {
        paymentsInfo: {
          isUpdated: false,
          value :firstStudent.paymentsInfo
        },
        statusStudent: {
          isUpdated: false,
          value : firstStudent.statusStudent
        },
        studentFunction: {
          isUpdated: false,
          value: firstStudent.studentFunction
        }
      },
      group: ids
    });
  }

  handleGroupEdit = (value) => {
    console.log(value)
    console.log(this.state.group)
    const { dispatch, data } = this.props;
    // console.log({
    //   _id: id,
    //   paymentsInfo: value.paymentsInfo
    // })
    // this.state.group.forEach( id => dispatch(updateStudent({
    //   _id: id,
    //   paymentsInfo: value.paymentsInfo
    // })))
    const students = this.state.group.map( id => data.find( x => x._id === id) );
    let update = {}
    Object.keys(value)
        .filter(key => value[key].isUpdated)
        .forEach(key => update[key] = value[key].value)

    students.forEach( student => dispatch(updateStudent({...student, ...update})))
  }

  createMail = (ids) => {
    this.setState({mailRecipients: ids});
    this.setState({editMail: true});
  }

  handleSearchChange = (searchType, value, exact = false) => {
    const { dispatch } = this.props;
    console.log(searchType, value)
    dispatch(removeFilterStudents(searchType));
    if (value !== 'All')
      dispatch(addFilterStudents(searchType, value.toLowerCase(), exact));
  }

  sendMails = (body, subject, tag) => {
    const { mailRecipients } = this.state;
    this.setState({isSending: true});
    if (mailRecipients.length) {
      const data = {
        students: mailRecipients,
        subject: subject,
        content: body,
        type: tag
      };
      fetch(API.SEND_MAILS, {
        method: 'POST',
        body: JSON.stringify(data),
        headers: new Headers(AUTH_HEADER)
      })
      .then(res => {
        if (res.ok) {
          return res.json();
        } else {
          throw new Error('Something went wrong ...');
        }
      })
      .then(res => {
        if (res.code == '011') {
          this.setState({sendingMail: false, editMail: false});
          alert("Wysyłanie rozpoczęte!");
        } else {
          throw new Error('Coś poszło nie tak!!@#!@#');
        }
      })
      .catch(error => {
        alert("Error" + error);
        this.setState({sendingMail: false, editMail: false});});
    }
    else {
      alert("Nie zaznaczono do kogo");
    }
  }

  handleUpdate = (student) => {
    this.props.dispatch(updateStudent(student));
  }

  componentDidMount = () => {
    this.props.dispatch(fetchAllStudents());
  }

  render() {
    const { editStudent, editMail, mailRecipients, isSending, filteredData, editGroup } = this.state;
    const { isLoading, error, data, rawData } = this.props;
    // console.log(filteredData)
    return (
      <div>
        <Toolbar title="< Panel admina | Studenci" titleUrl="/admin" />
        <div className="container">
          {
            isLoading ? <p>Loading that shit...</p> : (
              <div className="stats-filer-wrapper">
                <Stats data={data} />
                <Filter data={rawData} onChange={ (type, text, exact) => this.handleSearchChange(type, text, exact)} />
              </div>
            )
          }
          <AdvanceSearch onChange={this.handleSearchChange} />

          {/* <input type="search" className="cc-search-input" placeholder="Szukajka"
              onChange={this.handleSearchChange}
          /> */}
        {
          isLoading
            ? <p>Loading that shit...</p>
            : <StudentsTable title="Lista studentów"
              data={data}
              onDelete={this.deleteStudent}
              onEdit={this.handleEdit}
              // onSort={s => this.setState({sortBy: s})}
              onMailCreating={this.createMail}
              onGroupEdit={this.editGroup}
              onGroupDelete={this.deleteGroupStudent} />
          }
        </div>
        {
          editStudent &&
          <Modal onBlurClick={() => this.setState({editStudent: isLoading})}>
            <EditStudentForm initialValues={editStudent} onSubmit={this.handleUpdate} isSending={isLoading} />
          </Modal>
        }
        {
          editGroup &&
          <Modal onBlurClick={() => this.setState({editGroup: isLoading})}>
            <EditGroup initialValues={editGroup} onSubmit={this.handleGroupEdit} isSending={isLoading} />
          </Modal>
        }
        {
          editMail &&
          <Modal onBlurClick={() => this.setState({editMail: isLoading})}>
            <MakeMail onSubmit={this.sendMails} ids={mailRecipients} isSending={isSending} />
          </Modal>
        }
      </div>
    )
  }
};

const getFilteredData = (data, filters) => {
  console.log(filters)
  if(filters.length) {
      return data.filter(item => filters.every( filter => {
        if (filter.isExact)
          return item[filter.key].toString().toLowerCase() === filter.text;
        return item[filter.key].toString().toLowerCase().search(filter.text) !== -1;
      }));
  }
  return data;
}

export default connect(
  state => ({
    rawData: state.students.data,
    data: getFilteredData(state.students.data, state.students.filter),
    isLoading: state.students.isLoading,
    error: state.students.error
  })
)(ManageStudentsView);



// WEBPACK FOOTER //
// ./src/modules/Admin/views/ManageStudentsView.js